import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { ApiConfigurationCollection } from 'app/src/msw/companyagreement/initialSeed/apiConfiguration'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getApiConfiguration = http.get<object, DefaultBodyType, companyagreementApi.ApiConfiguration>(
  apiBaseUrl + '/',
  () => {
    const response: companyagreementApi.ApiConfiguration | undefined = ApiConfigurationCollection.findFirst()

    return HttpResponse.json(response)
  },
)
